import { useQuery } from '../lib/useQuery'
import { GetUnstableData } from '../graphql/docs'
import Segment from '../components/Segment'
import { Logger } from '@wolfdanepug/common-react'
import { useParams } from 'react-router'

export default function DogSegment() {
	const { data: onboardingData = {} } = useQuery(GetUnstableData, { context: 'onboarding' })
	const params = useParams()

	Logger.log('[Get Started] dogs dog segment', params, onboardingData)
	return <Segment path={params.segment} data={onboardingData?.data} />
}
